import { render, staticRenderFns } from "./resourceUri.vue?vue&type=template&id=130bd966&scoped=true"
import script from "./resourceUri.vue?vue&type=script&lang=js"
export * from "./resourceUri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130bd966",
  null
  
)

export default component.exports